'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _ramda = require('ramda');

var _collection_utility = require('common-utilities/src/collection_utility');

var _string_utility = require('../../../packages/common-utilities/src/string_utility');

var _functional_utility = require('../../../packages/common-utilities/src/functional_utility');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var GLOBAL_SCROLL_TOP = 0;
var INITIAL_TOC_TOP = 0;
var CARD_BOTTOM_MARGIN = 30;

var mapIndexed = (0, _ramda.addIndex)(_ramda.map);

var TableOfContents = function (_React$Component) {
  _inherits(TableOfContents, _React$Component);

  function TableOfContents(props) {
    _classCallCheck(this, TableOfContents);

    var _this = _possibleConstructorReturn(this, (TableOfContents.__proto__ || Object.getPrototypeOf(TableOfContents)).call(this, props));

    _this.state = {
      top: false,
      tocClassName: "position-absolute",
      tocStyle: {},
      containerId: "#" + _this.props.id + "-container",
      childCardClassName: "." + _this.props.id + "-child-card"
    };
    _this.setTableOfContentsTopValue = _this.setTableOfContentsTopValue.bind(_this);
    _this.generateTOCRows = _this.generateTOCRows.bind(_this);
    _this.getTOCParent = _this.getTOCParent.bind(_this);
    _this.updateTableOfContentsState = _this.updateTableOfContentsState.bind(_this);
    _this.onScroll = _this.onScroll.bind(_this);
    _this.onResize = _this.onResize.bind(_this);
    return _this;
  }

  _createClass(TableOfContents, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps() {
      INITIAL_TOC_TOP = 0;
      this.setState({
        tocClassName: "position-absolute",
        tocStyle: _collection_utility.CollectionUtility.merge(this.state.tocStyle, { width: this.getTOCParent().width() })
      }, this.setTableOfContentsTopValue);
    }
  }, {
    key: 'getTOCParent',
    value: function getTOCParent() {
      return (0, _jquery2.default)("#table-of-content-parent");
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.setTableOfContentsTopValue();
      this.props.window.addEventListener('scroll', this.onScroll);
      this.props.window.addEventListener('resize', this.onResize);
      this.setState({
        tocStyle: { width: this.getTOCParent().width() }
      });
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.window.removeEventListener('scroll', this.onScroll);
      this.props.window.removeEventListener('resize', this.onResize);
    }
  }, {
    key: 'getStickyHeader',
    value: function getStickyHeader() {
      return document.getElementsByClassName("sticky-header")[0];
    }
  }, {
    key: 'firstPortfolioChildCardIsScrolledIntoView',
    value: function firstPortfolioChildCardIsScrolledIntoView() {
      var windowTop = this.state.top;
      var windowBottom = windowTop + this.props.window.innerHeight;

      var portfolioChildCardTop = (0, _jquery2.default)(this.state.childCardClassName + ":first").offset().top;
      var portfolioChildCardBottom = portfolioChildCardTop + (0, _jquery2.default)(this.state.childCardClassName + ":first").height();

      return portfolioChildCardTop >= windowTop || portfolioChildCardTop <= windowTop && portfolioChildCardBottom >= windowBottom || portfolioChildCardBottom >= windowTop;
    }
  }, {
    key: 'firstPortfolioChildCardIsFullWidth',
    value: function firstPortfolioChildCardIsFullWidth() {

      return (0, _jquery2.default)(this.state.childCardClassName + ":first").width() > (0, _jquery2.default)(this.state.childCardClassName + ":visible:last").width();
    }
  }, {
    key: 'getOffsetHeightOfSecondPortfolioChildCard',
    value: function getOffsetHeightOfSecondPortfolioChildCard() {
      return document.querySelector(this.state.childCardClassName)[1].offsetHeight;
    }
  }, {
    key: 'onScroll',
    value: function onScroll() {
      var pocContainer = (0, _jquery2.default)("#portfolio-container");
      var tocEl = (0, _jquery2.default)("#table-of-contents");
      var stickyStopper = (0, _jquery2.default)("#toc-sticky-stopper");
      var toclElHeight = tocEl.innerHeight();
      var stickyStopperPosition = stickyStopper.offset() ? stickyStopper.offset().top : 0;
      var stopPoint = stickyStopperPosition - toclElHeight - CARD_BOTTOM_MARGIN;
      var startPoint = pocContainer.offset() ? pocContainer.offset().top : 0;
      GLOBAL_SCROLL_TOP = document.documentElement.scrollTop || document.body.scrollTop;
      if (typeof this.state.top !== "number") {
        return false;
      }
      this.handleScroll(stopPoint, GLOBAL_SCROLL_TOP, startPoint);
    }
  }, {
    key: 'onResize',
    value: function onResize() {
      if (!(0, _jquery2.default)("#table-of-contents").is(":visible")) {
        return false;
      }
      this.setState({
        tocStyle: _collection_utility.CollectionUtility.merge(this.state.tocStyle, { width: (0, _jquery2.default)("#table-of-content-parent").width() })
      });
      this.setTableOfContentsTopValue();
    }
  }, {
    key: 'handleScroll',
    value: function handleScroll(stopPoint, GLOBAL_SCROLL_TOP, startPoint) {
      if (this.props.isFlatMode && this.props.scrolledTab !== "portfolio") {
        return;
      }
      var stickyHeaderHeight = document.getElementsByClassName("sticky-header")[0] ? this.getStickyHeader().offsetHeight : 0;
      var additionalTopPadding = 30;
      var topTOC = void 0;
      if (this.props.isFlatMode) {
        topTOC = GLOBAL_SCROLL_TOP > this.state.top - stickyHeaderHeight - additionalTopPadding && stopPoint - stickyHeaderHeight > GLOBAL_SCROLL_TOP && GLOBAL_SCROLL_TOP > startPoint;
      } else {
        topTOC = GLOBAL_SCROLL_TOP > this.state.top - stickyHeaderHeight - additionalTopPadding && stopPoint - stickyHeaderHeight > GLOBAL_SCROLL_TOP;
      }
      var fixedTOC = this.state.top - stickyHeaderHeight - additionalTopPadding >= GLOBAL_SCROLL_TOP;
      var fixedBottomTOC = stopPoint - stickyHeaderHeight < GLOBAL_SCROLL_TOP;

      if (topTOC && this.state.tocClassName !== "position-fixed top-position") {
        this.updateTableOfContentsState("sticky");
      } else if (fixedTOC && this.state.tocClassName !== "position-absolute initial top-auto-important") {
        this.updateTableOfContentsState("top");
      } else if (fixedBottomTOC && this.state.tocClassName !== "position-absolute toc-bottom") {
        this.updateTableOfContentsState("bottom");
      }
    }
  }, {
    key: 'updateTableOfContentsState',
    value: function updateTableOfContentsState(tocState) {
      var tocStyle = {};
      var getTOCWidth = function getTOCWidth() {
        return (0, _ramda.isNil)(document.querySelector("#table-of-contents")) ? 0 : document.querySelector("#table-of-contents").offsetWidth;
      };

      if (tocState === "top") {
        tocStyle = {
          tocClassName: "position-absolute initial top-auto-important",
          tocStyle: {
            top: "initial",
            width: getTOCWidth()
          }
        };
      } else if (tocState === "sticky") {
        if (this.firstPortfolioChildCardIsFullWidth() && this.firstPortfolioChildCardIsScrolledIntoView()) {
          var secondCardOffsetHeight = this.getOffsetHeightOfSecondPortfolioChildCard();
          tocStyle = {
            tocClassName: "position-fixed top-position",
            tocStyle: {
              top: secondCardOffsetHeight,
              width: getTOCWidth()
            }
          };
        } else {
          var additionalTopSpace = 30;
          var stickHeaderHeight = this.getStickyHeader() ? this.getStickyHeader().offsetHeight + additionalTopSpace : 260 + additionalTopSpace;
          tocStyle = {
            tocClassName: "position-fixed top-position",
            tocStyle: {
              top: stickHeaderHeight,
              width: getTOCWidth()
            }
          };
        }
      } else if (tocState === "bottom") {
        tocStyle = {
          tocClassName: "position-absolute toc-bottom",
          tocStyle: {
            top: (0, _jquery2.default)(this.state.childCardClassName + ":last").length < 1 ? 0 : (0, _jquery2.default)(this.state.childCardClassName + ":last").position().top + (0, _jquery2.default)(this.state.childCardClassName + ":last").outerHeight(true) - (0, _jquery2.default)("#table-of-contents").height() - CARD_BOTTOM_MARGIN,
            width: getTOCWidth()
          }
        };
      }
      this.setState(tocStyle);
    }
  }, {
    key: 'setTableOfContentsTopValue',
    value: function setTableOfContentsTopValue() {
      if (!(0, _jquery2.default)("#table-of-contents").is(":visible") || !(0, _jquery2.default)(this.state.containerId).offset || INITIAL_TOC_TOP === this.state.top) {
        return false;
      }

      if (this.props.testTopPosition) {
        this.setState({ top: parseInt(1, 10) });
        return false;
      }

      if (INITIAL_TOC_TOP !== this.state.top) {
        if (INITIAL_TOC_TOP === 0) {
          INITIAL_TOC_TOP = parseInt((0, _jquery2.default)(this.state.containerId).offset().top, 10);
        }
        this.setState({ top: INITIAL_TOC_TOP });
      }
    }
  }, {
    key: 'generateTOCRows',
    value: function generateTOCRows() {
      var _this2 = this;

      var rowCollection = [];
      var activeCard = null;

      mapIndexed(function (cardId, i) {
        activeCard = _this2.props.activeCard === cardId;
        var config = Object.values(_this2.props.portfolioConfigs || {}).filter(function (config) {
          return config.id === _this2.props.headerIdArray[i];
        })[0];
        var updatedTOCName = !(0, _functional_utility.isNilOrEmpty)(_this2.props.visibleData) && (0, _ramda.includes)("SHOW_CASING_AS_TRANSLATION", _this2.props.visibleData.formattingRules) ? _this2.props.headerTextArray[i] : (0, _string_utility.toSentenceCase)(_this2.props.headerTextArray[i].toLowerCase());
        if (config && config.hideTOCTitle) {
          return;
        }
        rowCollection.push(_react2.default.createElement(
          'li',
          { key: i, className: 'text-align-center ' + (i === 0 ? 'border-top-1' : '') + ' ' + (activeCard ? 'no-triangle active body-bold background-white' : 'no-triangle') },
          _react2.default.createElement(
            'a',
            { href: '#', className: 'padding-vertical-15 padding-left-15 display-block width-percent-100 height-percent-100 toc-' + cardId, 'data-card-name': cardId, id: 'toc-' + cardId,
              onClick: _this2.props.goToCard.bind(_this2) },
            _react2.default.createElement(
              'span',
              { 'data-card-name': cardId, className: 'display-inline-block width-percent-85 ' + (activeCard ? 'font-black' : '') },
              updatedTOCName
            ),
            _react2.default.createElement('span', { 'data-card-name': cardId, className: 'pull-right toc-item-caret ' + (activeCard ? 'active' : '') })
          )
        ));
      }, this.props.headerIdArray);

      return rowCollection;
    }
  }, {
    key: 'render',
    value: function render() {
      if (this.state.top === 0 || typeof this.state.top === "boolean") {
        this.setTableOfContentsTopValue();
      }

      return _react2.default.createElement(
        'div',
        { id: 'table-of-contents', className: this.state.tocClassName, style: this.state.tocStyle },
        _react2.default.createElement(
          'ul',
          { 'data-testid': 'table-of-contents',
            className: 'toc-items' },
          this.generateTOCRows()
        )
      );
    }
  }]);

  return TableOfContents;
}(_react2.default.Component);

exports.default = TableOfContents;